import { ResponseFaqListGet, ResponseTopicListGet } from '../../api';
import { FaqApiService, IFaqApiService } from '../services/faq/faq.api.service';

export interface IFaqManagerProps {
    getTopicList(): Promise<ResponseTopicListGet>;
    getFaqList(id: string): Promise<ResponseFaqListGet>;
}

export class FaqManager implements IFaqManagerProps {
    private static instance: FaqManager;
    private faqService: IFaqApiService;

    private constructor() {
        this.faqService = FaqApiService.getInstance(process.env.REACT_APP_MICROSERVICE_FAQ_API_BASEPATH!);
    }

    static getInstance() {
        if (FaqManager.instance == null) {
            FaqManager.instance = new FaqManager();
        }
        return FaqManager.instance;
    }

    async getTopicList(): Promise<ResponseTopicListGet> {
        const response = await this.faqService.getTopicList();
        return response;
    }

    async getFaqList(id: string): Promise<ResponseFaqListGet> {
        const response = await this.faqService.getFaqList(id);
        return response;
    }
}
